import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		comarrLogin: Yup.string().required(t("fill_required_fields")),
		comarrPassword: Yup.string().required(t("fill_required_fields")),
	});
};
